<template>
    <div class="auth">
        <div class="auth-title">{{ $t('auth.registration') }}</div>
        <div class="auth-body">
            <hybrid-auth v-if="hybridAuth" type="sign_up"/>
            <div v-if="hybridAuth" class="auth-separator">
                <span>{{ $t('or') }}</span>
            </div>
            <div class="auth-login" :class="{'text-center': !hybridAuth}">
                <div class="auth-desc">{{ $t('descriptions.registration') }}</div>
                <button class="btn btn-primary btn-shadow text-uppercase" @click="register">
                    {{ $t('auth.sign_up_whit_email') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
  import HybridAuth from './HybridAuth';
  import registration from 'src/mixins/registrationComponent';

  export default {
    mixins: [registration],
    components: {
      HybridAuth,
    },
  };
</script>
